import React from 'react';
import { ICallLog } from 'store/callLog/callLog.state';
import { Button } from '@missionlabs/smartagent-app-components';
import {
    areDatesEqual,
    getMonthName,
    formatPhoneNumber,
    formatStartOfIntNumbers,
} from 'utils';
import classnames from 'classnames';
import OutboundIcon from 'images/icon-outbound-call.svg'
import './call-log.scss';
import { IDirectoryRecord } from 'store/directory/directory.state';
import useAppConfig from "hooks/redux/useAppConfig";

interface Props {
    contact: ICallLog;
    onClick: (contact: ICallLog) => void;
    selected?: boolean;
    directoryContact: IDirectoryRecord | null;
}

const CallLogComponent: React.FC<Props> = ({ contact, onClick, selected, directoryContact }) => {
    const appConfig = useAppConfig();
    const internalNumberLength = appConfig.internalNumberLength;

    const name = (directoryContact?.firstName ?? "") + " " + (directoryContact?.lastName ?? "")

    const getCallTime = (start: Date | number) => {
        if (!start) return '0:00';
        if (!(start instanceof Date)) {
            start = new Date(start);
        }
        let day = '';
        const today = new Date();
        if (!areDatesEqual(today, start)) {
            day = `${start.getDate()} ${getMonthName(start)} `;
        }
        let mins = start.getMinutes().toString();
        if (Number(mins) < 10) mins = '0' + mins;
        return day + start.getHours() + ':' + mins;
    };
    const getCallLength = (duration: number) => {
        const minutes = Math.floor(duration / 60);
        const seconds = duration % 60;
        return `Duration: ${minutes > 0 ? `${minutes}m ` : ''}${seconds}s`;
    };
    const isName = (name: string) => {
        if (name.length <= 1) {
            return contact.attributes['sa-customer-endpoint-address'] ?? "Customer"
        }
        return name
    }

    const renderPhoneNumber = () => {
        const number = contact.attributes['sa-dialled-number'] || contact.customerEndpointAddress;
        return formatPhoneNumber(
          formatStartOfIntNumbers(number, internalNumberLength)
        );
    }

    //Number is either the dialled-number attribute, contact number or fallback to call number;
    return (
        <li>
            <Button className="full-width call-log-button" onClick={() => onClick(contact)}>
                <div className={classnames({
                    "call-log": true,
                    "call-log-chat": contact.channel === "CHAT",
                    "row between": true,
                    selected
                })}>
                    {contact.channel === "VOICE" && (
                        <div className="call-log-icon">
                            {contact.initiationMethod === 'OUTBOUND' ? <img src={OutboundIcon} title="Outbound" alt="Outbound" /> : " "}
                        </div>
                    )}
                    <div className={classnames({
                        "call-log-details": true,
                        "call-log-task": contact.channel === "TASK"
                    })}>
                        <div className="call-log-main row">
                            <span className="call-log-name">
                                {isName(name)}
                            </span>
                            <span className="call-log-number">
                                {contact.channel === "VOICE" && renderPhoneNumber()}
                            </span>
                        </div>
                        <div className="call-log-type">
                            <time>{getCallLength(contact.agentInteractionDuration ?? 0)}</time>
                            <time className="call-log-time">{getCallTime(contact.connectedToAgentTimestamp ?? contact.initiationTimestamp)}</time>
                        </div>
                    </div>
                </div>
            </Button>
        </li>
    );
}

export default CallLogComponent;